<!--<p>footer works!</p>-->
<div class="footer d-flex justify-content-between align-items-center">
    <div class="copyright">© Copyright {{curYear}} StudyTest - мы развиваемся вместе с вами</div>

</div>
